import { isFunction } from 'lodash';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useBuildInputId } from '../KskForm/KskForm';

const KskInputHidden = React.forwardRef((
  { name, id, form, onChange, value, ...otherProps },  
  ref
) => {
  const _id = useBuildInputId({ id, name });

  return (
  <Controller
    control={form?.control}
    name={name}
    defaultValue={value ?? ''}
    render={({ field }) => (
      <input
        {...field}
        type="hidden"
        value={field.value ?? ''}
        onChange={(e) => {
          isFunction(onChange) && onChange(e);
          field.onChange(e);     // 🔥 FIX DEFINITIVO
          form?.trigger(name);
        }}
      />
    )}
  />
  );
});

export default KskInputHidden;
